// --- Pendo Agent Analytics Helper (Client-Side) ---

const CONTENT_MAX_LENGTH = 500;

export type TrackAgentEventType = 'prompt' | 'agent_response' | 'user_reaction';

export type TrackAgentEventMetadata = {
  agentId: string;
  conversationId: string;
  messageId: string;
  content: string;
  modelUsed?: string;
  suggestedPrompt?: boolean;
  toolsUsed?: string[];
  fileUploaded?: boolean;
};

export const trackAgentEvent = (
  eventType: TrackAgentEventType,
  metadata: TrackAgentEventMetadata,
): void => {
  try {
    if (typeof window === 'undefined' || !window.pendo?.trackAgent) {
      return;
    }
    window.pendo.trackAgent(eventType, {
      ...metadata,
      content:
        metadata.content.length > CONTENT_MAX_LENGTH
          ? metadata.content.slice(0, CONTENT_MAX_LENGTH)
          : metadata.content,
    });
  } catch {
    // Analytics failure must never break the product
  }
};
